import React, { useState } from "react";
import { useAuth } from "@/lib/auth";
import { LogOut, User as UserIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function UserBadge() {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  if (!user) return null;

  const handleLogout = async () => {
    await logout();
    setOpen(false);
    navigate("/", { replace: true });
  };

  const initial = (user.name || user.email || "?").trim().charAt(0).toUpperCase();

  return (
    <div className="relative" data-testid="user-badge">
      <button
        onClick={() => setOpen((v) => !v)}
        data-testid="user-badge-btn"
        className="flex items-center gap-3 group"
        aria-label="User menu"
      >
        {user.picture ? (
          <img
            src={user.picture}
            alt=""
            referrerPolicy="no-referrer"
            className="h-8 w-8 rounded-full border border-obsidian-600 group-hover:border-terracotta transition-colors object-cover"
          />
        ) : (
          <div className="h-8 w-8 rounded-full border border-obsidian-600 group-hover:border-terracotta transition-colors bg-obsidian-700 flex items-center justify-center font-serif text-sm text-bone-200">
            {initial}
          </div>
        )}
        <span className="hidden md:inline font-sans text-xs uppercase tracking-[0.2em] text-bone-400 group-hover:text-bone-200 transition-colors">
          {user.name?.split(" ")[0] || user.email}
        </span>
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-30" onClick={() => setOpen(false)} />
          <div
            className="absolute right-0 mt-3 min-w-[220px] bg-obsidian-800 border border-obsidian-600 z-40 animate-fade-up"
            data-testid="user-menu"
          >
            <div className="px-4 py-3 border-b border-obsidian-600">
              <p className="font-serif text-sm text-bone-100 truncate">{user.name}</p>
              <p className="font-sans text-[0.7rem] text-bone-500 truncate mt-1">{user.email}</p>
            </div>
            <button
              onClick={handleLogout}
              data-testid="logout-btn"
              className="w-full text-left px-4 py-3 font-sans text-xs uppercase tracking-[0.2em] text-bone-300 hover:text-terracotta hover:bg-obsidian-700 transition-colors flex items-center gap-3"
            >
              <LogOut className="h-3.5 w-3.5" /> Sign out
            </button>
          </div>
        </>
      )}
    </div>
  );
}
